//---------------------------
// is characteristic changed
//---------------------------
export default function isCharacteristicChanged(pfx, original, now) {
  // console.log('----------------------------')
  // console.log('IN isCharacteristicChanged')
  // console.log('----------------------------')
  // console.log("ORIGINAL...")
  // window.displayPairs(original)
  // console.log("----------------------------")
  // console.log("NOW...")
  // window.displayPairs(now)
  // console.log("----------------------------")
  // console.log('pfx = ', pfx)
  // console.log('original rolled = ' + original[pfx + '_rolled'])
  // console.log('original improvs_tot = ' + original[pfx + '_improvs_tot'])
  // console.log('now rolled = ' + now[pfx + '_rolled'])
  // console.log('now improvs_tot = ' + now[pfx + '_improvs_tot'])
  // console.log('----------------------------')
  if (
    original[pfx + '_rolled'] != now[pfx + '_rolled'] ||
    original[pfx + '_improvs_tot'] != now[pfx + '_improvs_tot']
  ) {
    // console.log('VALUE CHANGED ', pfx)
    return true
  } else {
    // console.log('VALUE NOT CHANGED ', pfx)
    return false
  }
}
